export default __webpack_public_path__ + "static/media/assistencia24h.3e598f78.png";